import React from 'react';
interface AuroraBackdropProps {
  /** Landing uses the richer, more saturated field of light. */
  intensity?: 'app' | 'marketing';
}

/** Fixed, decorative gradient field that sits behind every glass surface. */
export function AuroraBackdrop({
  intensity = 'app'
}: AuroraBackdropProps) {
  const strong = intensity === 'marketing';
  return <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-background" data-id="element-39" data-mp="10ehi6neciwp5">
      <div className="absolute -left-32 -top-40 rounded-full animate-aurora" style={{
      width: strong ? 620 : 480,
      height: strong ? 620 : 480,
      background: 'radial-gradient(circle at 30% 30%, var(--aurora-1), transparent 70%)',
      filter: 'blur(20px)'
    }} data-id="element-40" data-mp="1e91uymrtuny9" />
      <div className="absolute -right-24 top-10 rounded-full animate-aurora" style={{
      width: strong ? 560 : 420,
      height: strong ? 560 : 420,
      background: 'radial-gradient(circle at 60% 40%, var(--aurora-2), transparent 70%)',
      filter: 'blur(24px)',
      animationDelay: '-6s'
    }} data-id="element-41" data-mp="3pwhy46lj0abz" />
      <div className="absolute bottom-[-14rem] left-1/3 rounded-full animate-aurora" style={{
      width: strong ? 700 : 520,
      height: strong ? 700 : 520,
      background: 'radial-gradient(circle at 50% 50%, var(--aurora-3), transparent 70%)',
      filter: 'blur(28px)',
      animationDelay: '-12s'
    }} data-id="element-42" data-mp="2q236h7b58re5" />
      <div className="absolute inset-0 opacity-[0.35] dark:opacity-[0.18]" style={{
      backgroundImage: 'linear-gradient(to right, var(--glass-hairline) 1px, transparent 1px), linear-gradient(to bottom, var(--glass-hairline) 1px, transparent 1px)',
      backgroundSize: '68px 68px',
      maskImage: 'radial-gradient(ellipse at 50% 0%, black, transparent 78%)',
      WebkitMaskImage: 'radial-gradient(ellipse at 50% 0%, black, transparent 78%)'
    }} data-id="element-43" data-mp="38r9qqyrl5r22" />
    </div>;
}